module.exports = __webpack_public_path__ + "static/1-014-5898eae786369ac82bc8650f46166697.png";